function Footer() {
  return (
    <footer className="footer-area">
      <div className="container">
        <div className="text text-center">
          <p>2025 © Made with love by Flávia</p>{" "}
        </div>
      </div>
    </footer>
  );
}
export default Footer;
